var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getName},[_c('article',{staticClass:"h-article",domProps:{"innerHTML":_vm._s(_vm.ArticleData.NewsContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }